// eslint-disable-next-line no-use-before-define
import React from 'react';

import { DELETE_OAR, OAR_QUERY } from './Queries';
import {
  GET_CAREPLAN,
  SITE_TEMPLATE_VALUES_BY_PRESCRIPTION_VARIATION,
  VOLUMING_TEMPLATE_VALUE_VARIATION,
} from '../../Queries';
import { useMutation } from '@apollo/client';
import { Edit, DeleteOutline } from '@mui/icons-material';
import { Typography, Button, useTheme } from '@mui/material';

export interface OrgansAtRiskRowProps {
  organName: string;
  constraints: string[];
  itemId?: any;
  data?: any;
  popup?: any;
  hidePopup?: any;
  isVisible?: boolean;
  editPopup: () => void;
  prescriptionId: string;
  careplanId: number;
  index: number;
}

const OrgansAtRiskRow = ({
  organName,
  constraints,
  prescriptionId,
  careplanId,
  editPopup,
  index,
}: OrgansAtRiskRowProps): JSX.Element => {
  const theme = useTheme();
  const [deleteOAR, { loading }] = useMutation(DELETE_OAR, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: OAR_QUERY,
        variables: { prescriptionId: prescriptionId },
      },
      {
        query: VOLUMING_TEMPLATE_VALUE_VARIATION,
        variables: { prescriptionId },
      },
      {
        query: SITE_TEMPLATE_VALUES_BY_PRESCRIPTION_VARIATION,
        variables: { prescriptionId, volumingPage: true },
      },
      { query: GET_CAREPLAN, variables: { id: careplanId } },
    ],
  });

  return (
    <>
      <tr className="no-border-table-row">
        <td></td>
      </tr>
      <tr className="oar-table-row">
        <td>
          <Typography variant="body1">{organName}</Typography>
        </td>
        <td>
          {constraints.map(
            (item, index): JSX.Element => (
              <Typography variant="body1" key={index}>
                {item}
              </Typography>
            ),
          )}
        </td>
        <td>
          <Button
            onClick={(): void => editPopup()}
            variant="text"
            sx={{
              '&:hover': {
                '.MuiSvgIcon-root': { color: theme.palette.primary.light },
              },
            }}
            data-testid={`edit-oar-button-${index}`}
            startIcon={<Edit color="primary" />}>
            <Typography variant="body1">Edit</Typography>
          </Button>
        </td>
        <td>
          <Button
            onClick={() => deleteOAR({ variables: { prescriptionId, index } })}
            variant="text"
            sx={{ '&:hover': { '.MuiSvgIcon-root': { color: theme.palette.error.light } } }}
            data-testid={`delete-oar-button-${index}`}
            startIcon={<DeleteOutline color="error" />}
            disabled={loading}>
            <Typography variant="body1">Delete</Typography>
          </Button>
        </td>
      </tr>
    </>
  );
};

export default OrgansAtRiskRow;
